export const BooleanColumns: string[] = [
  'isClimate',
  'isCovered',
  'isAvailable',
]
